// Commerce tag — override via REACT_APP_COMMERCE_TAG on Netlify.
export const COMMERCE_TAG =
  process.env.REACT_APP_COMMERCE_TAG || "";

// Builds a neutral product search placeholder URL.
// Replace with real commerce endpoints at launch.
export function productSearch(query) {
  const q = encodeURIComponent(String(query || "").trim());
  if (!q) return "#product-LINK";
  return `/shop?q=${q}`;
}

export function productUrl(sku) {
  if (!sku) return "#product-LINK";
  return "#product-LINK";
}
